import { Helmet } from "react-helmet";
import AppsFaqsBody from "../../components/faqs/AppsFaqsBody";
import RelatedApp from "../../components/solutions/app/RelatedApp";
import Authority from "../../components/reusables/Authority";
import SolutionCTA from "../../components/solutions/SolutionCTA";
import HowWeWork from "../../components/solutions/HowWeWork";
import SolutionItemHero from "../../components/reusables/hero/SolutionItemHero";
import AppDevelopment from "../../components/solutions/app/AppDevelopment";

export default function Apps() {
  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ntuna.com/solutions/mobile-apps-development"
        />
        <meta
          name="description"
          content="Android, iOS, and hybrid mobile application development with API integrations."
        />
        <meta
          property="og:description"
          content="Android, iOS, and hybrid mobile application development with API integrations."
        />
        <meta
          property="og:title"
          content="NTUNA.COM | Solutions | Mobile App Development | Android & iOS"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627082/ntuna_solutions_banner_1200x628_c8xerm.jpg"
        />

        <meta
          name="twitter:title"
          content="NTUNA.COM | Solutions | Mobile App Development | Android & iOS"
        />
        <meta
          name="twitter:text:title"
          content="NTUNA.COM | Solutions | Mobile App Development | Android & iOS"
        />
        <meta
          name="twitter:description"
          content="Android, iOS, and hybrid mobile application development with API integrations."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627082/ntuna_solutions_banner_1200x628_c8xerm.jpg"
        />
        <title>
          NTUNA.COM | Solutions | Mobile App Development | Android & iOS
        </title>
      </Helmet>
      <SolutionItemHero
        title="Mobile App Development [Android & iOS]"
        subtitle="Custom mobile apps that deliver seamless user experiences, integrate with your systems and drive real business growth and institutional efficiency."
        casestudylink="/#"
        CTAtext="Get Free Quote"
        mainCTAlink="https://form.jotform.com/ntuna/get-free-quote"
      />
      <Authority />
      <AppDevelopment />
      <SolutionCTA ctaTitle="Ready To Have Your Mobile App?" />
      <AppsFaqsBody />
      <SolutionCTA ctaTitle="Ready To Have Your Mobile App?" />
      <HowWeWork />
      <SolutionCTA ctaTitle="Ready To Have Your Mobile App?" />
      <RelatedApp />
    </>
  );
}
